// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { parseInterferenceParameter } from 'redux/modules/interferenceAnalysis/helpers'

// takes an array of band parameters for interference analysis
// and preps them for display through redux-form

const parseInterferenceParameters = (parameters, unitType, propagationModels) => (
  parameters.map(d => (
    parseInterferenceParameter(d, unitType, propagationModels)
  ))
)

export default parseInterferenceParameters
